import Bowser from 'bowser'

import {
   SUPPORTED_CHROME_VERSION,
   SUPPORTED_EDGE_VERSION,
   SUPPORTED_FIREFOX_VERSION,
   SUPPORTED_SAFARI_VERSION,
   USER_AGENT_CHROME_KEY,
   USER_AGENT_EDGE_KEY,
   USER_AGENT_FIREFOX_KEY,
   USER_AGENT_GOOGLE_SEARCH_KEY,
   USER_AGENT_SAFARI_KEY
} from '../../constants/BrowserConstants'
import { CrossBrowserCompatibility } from '../../types'

interface ReturnType {
   getCrossBrowserCompatibility: () => CrossBrowserCompatibility
}

const useGetCrossBrowserDetails = (): ReturnType => {
   const getCrossBrowserCompatibility = (): CrossBrowserCompatibility => {
      const parsedUa = Bowser.getParser(window.navigator.userAgent)
      const browserName = parsedUa.getBrowserName()

      switch (browserName) {
         case USER_AGENT_SAFARI_KEY:
            return {
               browserName: USER_AGENT_SAFARI_KEY,
               isVersionSupported: !!parsedUa.satisfies({
                  safari: `>=${SUPPORTED_SAFARI_VERSION}`
               })
            }
         case USER_AGENT_CHROME_KEY:
         case USER_AGENT_GOOGLE_SEARCH_KEY:
            return {
               browserName: USER_AGENT_CHROME_KEY,
               isVersionSupported: !!parsedUa.satisfies({
                  chrome: `>=${SUPPORTED_CHROME_VERSION}`
               })
            }
         case USER_AGENT_FIREFOX_KEY:
            return {
               browserName: USER_AGENT_FIREFOX_KEY,
               isVersionSupported: !!parsedUa.satisfies({
                  firefox: `>=${SUPPORTED_FIREFOX_VERSION}`
               })
            }
         case USER_AGENT_EDGE_KEY:
            return {
               browserName: USER_AGENT_EDGE_KEY,
               isVersionSupported: !!parsedUa.satisfies({
                  edge: `>=${SUPPORTED_EDGE_VERSION}`
               })
            }
         default:
            return {
               browserName: browserName,
               isVersionSupported: false
            }
      }
   }

   return { getCrossBrowserCompatibility }
}

export default useGetCrossBrowserDetails
